'use strict';

var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof global !== 'undefined') {
  win = global;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

module.exports = win;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-infinite/build/utils/window.js
// module id = 6
// module chunks = 0